import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgTrendingDown = function SvgTrendingDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    height: 24,
    width: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m15 17.25c0 .4142.3358.75.75.75h5.5c.4142 0 .75-.3358.75-.75v-5.5c0-.4142-.3358-.75-.75-.75s-.75.3358-.75.75v3.6793l-5.5558-5.5478c-1.0742-1.0727-2.8143-1.072-3.8877.0014l-1.17262 1.1726c-.48815.4881-1.27961.4881-1.76776 0l-4.83579-4.8358c-.29289-.2929-.76777-.2929-1.06066 0s-.29289.7677 0 1.0606l4.83579 4.8358c1.07394 1.074 2.81514 1.074 3.88904 0l1.1726-1.1726c.4879-.4879 1.2789-.4882 1.7672-.0006l5.5651 5.5571h-3.6994c-.4142 0-.75.3358-.75.75z",
    fillRule: "evenodd"
  })));
};

export { SvgTrendingDown as ReactComponent };
//# sourceMappingURL=trending-down.svg.js.map
